__turbopack_context__.v({
  "toggle": "Toggle-module__XZrISa__toggle",
  "toggleDisabled": "Toggle-module__XZrISa__toggleDisabled",
  "toggleSmall": "Toggle-module__XZrISa__toggleSmall",
  "toggle__toggleLabel": "Toggle-module__XZrISa__toggle__toggleLabel",
  "toggle__toggleLabel__reverse": "Toggle-module__XZrISa__toggle__toggleLabel__reverse",
  "toggle__toggleMark": "Toggle-module__XZrISa__toggle__toggleMark",
  "toggle__toggleMark__reverse": "Toggle-module__XZrISa__toggle__toggleMark__reverse",
});
